/**
 * Localization strings that are shared across components
 *
 * @module
 */

import { createDictionary } from './utils';

// Refer to "Guidelines for Programmers" in ./README.md before editing this file

export const commonText = createDictionary({
  specifySeven: {
    comment: `
      This is an example of how to provide comments. Comments are visible to
      translators.
    `,
    'en-us': 'Specify 7',
    'ru-ru': 'Укажите 7',
    'es-es': 'Specify 7',
    'fr-fr': 'Specify 7',
    'uk-ua': 'Вкажіть 7',
    'de-ch': 'Specify 7',
    'pt-br': 'Specify 7',
  },
  no: {
    'en-us': 'No',
    'ru-ru': 'Нет',
    'es-es': 'No',
    'fr-fr': 'Non',
    'uk-ua': 'Немає',
    'de-ch': 'Nein',
    'pt-br': 'Não',
  },
  cancel: {
    'en-us': 'Cancel',
    'ru-ru': 'Отмена',
    'es-es': 'Cancelar',
    'fr-fr': 'Annuler',
    'uk-ua': 'Скасувати',
    'de-ch': 'Abbrechen',
    'pt-br': 'Cancelar',
  },
  back: {
    'en-us': 'Back',
    'ru-ru': 'Назад',
    'es-es': 'Atrás',
    'fr-fr': 'Dos',
    'uk-ua': 'Назад',
    'de-ch': 'Zurück',
    'pt-br': 'Voltar',
  },
  skip: {
    'en-us': 'Skip',
    'ru-ru': 'Пропускать',
    'es-es': 'Omitir',
    'fr-fr': 'Sauter',
    'uk-ua': 'Пропустити',
    'de-ch': 'Überspringen',
    'pt-br': 'Pular',
  },
  create: {
    'en-us': 'Create',
    'ru-ru': 'Создать',
    'es-es': 'Crear',
    'fr-fr': 'Créer',
    'uk-ua': 'Створити',
    'de-ch': 'Erstellen',
    'pt-br': 'Criar',
  },
  close: {
    'en-us': 'Close',
    'ru-ru': 'Закрыть',
    'es-es': 'Cerrar',
    'fr-fr': 'Fermer',
    'uk-ua': 'Закрити',
    'de-ch': 'Schliessen',
    'pt-br': 'Fechar',
  },
  apply: {
    'en-us': 'Apply',
    'ru-ru': 'Применить',
    'es-es': 'Aplicar',
    'fr-fr': 'Appliquer',
    'uk-ua': 'Застосувати',
    'de-ch': 'Anwenden',
    'pt-br': 'Aplicar',
  },
  applyAll: {
    'en-us': 'Apply All',
    'ru-ru': 'Применить все',
    'es-es': 'Aplicar todo',
    'fr-fr': 'Appliquer tout',
    'uk-ua': 'Застосувати все',
    'de-ch': 'Alle Anwenden',
    'pt-br': 'Aplicar tudo',
  },
  clearAll: {
    'en-us': 'Clear all',
    'ru-ru': 'Очистить все',
    'es-es': 'Borrar todo',
    'fr-fr': 'Tout effacer',
    'uk-ua': 'Очистити все',
    'de-ch': 'Alles löschen',
    'pt-br': 'Limpar tudo',
  },
  deleteUnmapped: {
    'en-us': 'Delete unmapped columns',
    'de-ch': 'Nicht zugeordnete Spalten löschen',
    'es-es': 'Eliminar columnas no asignadas',
    'fr-fr': 'Supprimer les colonnes non mappées',
    'pt-br': 'Excluir colunas não mapeadas',
    'ru-ru': 'Удаление неотображенных столбцов',
    'uk-ua': 'Видалити незіставлені стовпці',
  },
  save: {
    'en-us': 'Save',
    'ru-ru': 'Сохранить',
    'es-es': 'Guardar',
    'fr-fr': 'Sauvegarder',
    'uk-ua': 'зберегти',
    'de-ch': 'Speichern',
    'pt-br': 'Salvar',
  },
  add: {
    'en-us': 'Add',
    'ru-ru': 'Добавить',
    'es-es': 'Añadir',
    'fr-fr': 'Ajouter',
    'uk-ua': 'додати',
    'de-ch': 'Hinzufügen',
    'pt-br': 'Adicionar',
  },
  open: {
    'en-us': 'Open',
    'ru-ru': 'Открыть',
    'es-es': 'Abrir',
    'fr-fr': 'Ouvrir',
    'uk-ua': 'ВІДЧИНЕНО',
    'de-ch': 'Öffnen',
    'pt-br': 'Abrir',
  },
  delete: {
    'en-us': 'Delete',
    'es-es': 'Eliminar',
    'fr-fr': 'Supprimer',
    'uk-ua': 'Видалити',
    'de-ch': 'Löschen',
    'ru-ru': 'Удалить',
    'pt-br': 'Excluir',
  },
  next: {
    'en-us': 'Next',
    'ru-ru': 'Следующий',
    'es-es': 'Siguiente',
    'fr-fr': 'Suivant',
    'uk-ua': 'Далі',
    'de-ch': 'Weiter',
    'pt-br': 'Próximo',
  },
  previous: {
    'en-us': 'Previous',
    'ru-ru': 'Предыдущий',
    'es-es': 'Anterior',
    'fr-fr': 'Précédent',
    'uk-ua': 'Попередній',
    'de-ch': 'Zurück',
    'pt-br': 'Anterior',
  },
  tool: {
    'en-us': 'Tool',
    'ru-ru': 'Инструмент',
    'es-es': 'Herramienta',
    'fr-fr': 'Outil',
    'uk-ua': 'Інструмент',
    'de-ch': 'Tool',
    'pt-br': 'Ferramenta',
  },
  tools: {
    'en-us': 'Tools',
    'ru-ru': 'Инструменты',
    'es-es': 'Herramientas',
    'fr-fr': 'Outils',
    'uk-ua': 'Інструменти',
    'de-ch': 'Tools',
    'pt-br': 'Ferramentas',
  },
  loading: {
    'en-us': 'Loading…',
    'ru-ru': 'Загрузка…',
    'es-es': 'Cargando…',
    'fr-fr': 'Chargement…',
    'uk-ua': 'Завантажуємо…',
    'de-ch': 'Laden …',
    'pt-br': 'Carregando…',
  },
  uploaded: {
    'en-us': 'Uploaded',
    'ru-ru': 'Загружено',
    'es-es': 'Subido',
    'fr-fr': 'Téléchargé',
    'uk-ua': 'Завантажено',
    'de-ch': 'Hochgeladen',
    'pt-br': 'Enviado',
  },
  remove: {
    'en-us': 'Remove',
    'ru-ru': 'Удалить',
    'es-es': 'Eliminar',
    'fr-fr': 'Retirer',
    'uk-ua': 'видалити',
    'de-ch': 'Entfernen',
    'pt-br': 'Remover',
  },
  search: {
    'en-us': 'Search',
    'ru-ru': 'Поиск',
    'es-es': 'Buscar',
    'fr-fr': 'Recherche',
    'uk-ua': 'Пошук',
    'de-ch': 'Suche',
    'pt-br': 'Procurar',
  },
  noResults: {
    'en-us': 'No Results',
    'ru-ru': 'Нет результатов',
    'es-es': 'Sin resultados',
    'fr-fr': 'Aucun résultat',
    'uk-ua': 'Немає результатів',
    'de-ch': 'Keine Resultate',
    'pt-br': 'Nenhum resultado',
  },
  notApplicable: {
    'en-us': 'N/A',
    'ru-ru': 'Н/Д',
    'es-es': 'N/D',
    'fr-fr': 'N/A',
    'uk-ua': 'N/A',
    'de-ch': 'N/A',
    'pt-br': 'N / D',
  },
  new: {
    'en-us': 'New',
    'ru-ru': 'Новый',
    'es-es': 'Nuevo',
    'fr-fr': 'Nouveau',
    'uk-ua': 'новий',
    'de-ch': 'Neu',
    'pt-br': 'Novo',
  },
  edit: {
    'en-us': 'Edit',
    'ru-ru': 'Редактировать',
    'es-es': 'Editar',
    'fr-fr': 'Modifier',
    'uk-ua': 'Редагувати',
    'de-ch': 'Bearbeiten',
    'pt-br': 'Editar',
  },
  ignore: {
    'en-us': 'Ignore',
    'ru-ru': 'Игнорировать',
    'es-es': 'Ignorar',
    'fr-fr': 'Ignorer',
    'uk-ua': 'Ігнорувати',
    'de-ch': 'Ignorieren',
    'pt-br': 'Ignorar',
  },
  proceed: {
    'en-us': 'Proceed',
    'ru-ru': 'Продолжить',
    'es-es': 'Proceder',
    'fr-fr': 'Procéder',
    'uk-ua': 'Продовжуйте',
    'de-ch': 'Fortfahren',
    'pt-br': 'Prosseguir',
  },
  start: {
    comment: 'Noun',
    'en-us': 'Start',
    'ru-ru': 'Начать',
    'es-es': 'Empezar',
    'fr-fr': 'Commencer',
    'uk-ua': 'старт',
    'de-ch': 'Start',
    'pt-br': 'Começar',
  },
  end: {
    comment: 'Noun',
    'en-us': 'End',
    'ru-ru': 'Конец',
    'es-es': 'Fin',
    'fr-fr': 'Fin',
    'uk-ua': 'Кінець',
    'de-ch': 'Ende',
    'pt-br': 'Fim',
  },
  update: {
    comment: 'Verb',
    'en-us': 'Update',
    'ru-ru': 'Обновить',
    'es-es': 'Actualizar',
    'fr-fr': 'Mise à jour',
    'uk-ua': 'оновлення',
    'de-ch': 'Aktualisieren',
    'pt-br': 'Atualizar',
  },
  fullDate: {
    'en-us': 'Full Date',
    'es-es': 'Fecha completa',
    'de-ch': 'Vollständiges Datum',
    'fr-fr': 'Date complète',
    'ru-ru': 'Полная дата',
    'uk-ua': 'Розгорнути все',
    'pt-br': 'Data completa',
  },
  view: {
    comment: 'Verb',
    'en-us': 'View',
    'ru-ru': 'Вид',
    'es-es': 'Ver',
    'fr-fr': 'Voir',
    'uk-ua': 'Переглянути',
    'de-ch': 'Ansicht',
    'pt-br': 'Visualizar',
  },
  opensInNewTab: {
    comment: 'Used in a hover-over message for links that open in new tab',
    'en-us': '(opens in a new tab)',
    'ru-ru': '(открывается в новой вкладке)',
    'es-es': '(se abre en una pestaña nueva)',
    'uk-ua': '(відкривається в новій вкладці)',
    'de-ch': '(Öffnet sich in einer neuen Registerkarte)',
    'fr-fr': "(s'ouvre dans un nouvel onglet)",
    'pt-br': '(abre em uma nova aba)',
  },
  openInNewTab: {
    comment: 'Used in a button that opens a link in a new tab',
    'en-us': 'Open in New Tab',
    'ru-ru': 'Открыть в новой вкладке',
    'es-es': 'Abrir en una pestaña nueva',
    'fr-fr': 'Ouvrir dans un nouvel onglet',
    'uk-ua': 'Відкрити в новій вкладці',
    'de-ch': 'Öffnet sich in einer neuen Registerkarte',
    'pt-br': 'Abrir em Nova Aba',
  },
  goToHomepage: {
    'en-us': 'Go to Home Page',
    'ru-ru': 'Перейти на домашнюю страницу',
    'es-es': 'Ir a la página de inicio',
    'fr-fr': "Accéder à la page d'accueil",
    'uk-ua': 'Перейдіть на домашню сторінку',
    'de-ch': 'Zur Startseite gehen',
    'pt-br': 'Ir Para a Página Inicial',
  },
  actions: {
    'en-us': 'Actions',
    'ru-ru': 'Действия',
    'es-es': 'Comportamientos',
    'fr-fr': 'Actes',
    'uk-ua': 'Дії',
    'de-ch': 'Aktionen',
    'pt-br': 'Ações',
  },
  chooseCollection: {
    'en-us': 'Choose Collection',
    'ru-ru': 'Выбрать коллекцию',
    'es-es': 'Elegir Colección',
    'fr-fr': 'Choisir une collection',
    'uk-ua': 'Виберіть колекцію',
    'de-ch': 'Sammlung auswählen',
    'pt-br': 'Escolha a Coleção',
  },
  ascending: {
    comment: 'As in "Ascending sort"',
    'en-us': 'Ascending',
    'ru-ru': 'По возрастанию',
    'es-es': 'Ascendente',
    'fr-fr': 'Ascendant',
    'uk-ua': 'Висхідний',
    'de-ch': 'Aufsteigend',
    'pt-br': 'Ascendente',
  },
  descending: {
    comment: 'As in "Descending sort"',
    'en-us': 'Descending',
    'ru-ru': 'По убыванию',
    'es-es': 'Descendente',
    'fr-fr': 'Descendant',
    'uk-ua': 'Спускається',
    'de-ch': 'Absteigend',
    'pt-br': 'Descendente',
  },
  recordSets: {
    'en-us': 'Record Sets',
    'ru-ru': 'Наборы записей',
    'es-es': 'Conjuntos de registros',
    'fr-fr': "Ensembles d'enregistrements",
    'uk-ua': 'Набори рекордів',
    'de-ch': 'Satzgruppen',
    'pt-br': 'Conjuntos de discos',
  },
  recordCount: {
    'en-us': 'Record Count',
    'ru-ru': 'Количество записей',
    'es-es': 'Número de registros',
    'fr-fr': 'Nombre de records',
    'uk-ua': 'Підрахунок записів',
    'de-ch': 'Anzahl der Datensätze',
    'pt-br': 'Contagem de recordes',
  },
  size: {
    'en-us': 'Size',
    'ru-ru': 'Размер',
    'es-es': 'Tamaño',
    'fr-fr': 'Taille',
    'uk-ua': 'Розмір',
    'de-ch': 'Grösse',
    'pt-br': 'Tamanho',
  },
  running: {
    'en-us': 'Running…',
    'ru-ru': 'Бег…',
    'es-es': 'Ejecutando…',
    'fr-fr': "En cours d'exécution…",
    'uk-ua': 'Виконується…',
    'de-ch': 'In Arbeit …',
    'pt-br': 'Correndo…',
  },
  noMatches: {
    'en-us': 'No Matches',
    'ru-ru': 'Нет совпадений',
    'es-es': 'No hay coincidencias',
    'fr-fr': 'Aucune correspondance',
    'uk-ua': 'Немає збігів',
    'de-ch': 'Keine Treffer',
    'pt-br': 'Nenhum resultado encontrado',
  },
  searchQuery: {
    'en-us': 'Search Query',
    'ru-ru': 'Поисковый запрос',
    'es-es': 'Consulta de busqueda',
    'fr-fr': 'Requête de recherche',
    'uk-ua': 'Пошуковий запит',
    'de-ch': 'Suchabfrage',
    'pt-br': 'Consulta de pesquisa',
  },
  unknown: {
    'en-us': 'Unknown',
    'ru-ru': 'Неизвестный',
    'es-es': 'Desconocido',
    'fr-fr': 'Inconnu',
    'uk-ua': 'Невідомий',
    'de-ch': 'Unbekannt',
    'pt-br': 'Desconhecido',
  },
  language: {
    'en-us': 'Language',
    'ru-ru': 'Язык',
    'es-es': 'Idioma',
    'fr-fr': 'Langue',
    'uk-ua': 'Мова',
    'de-ch': 'Sprache',
    'pt-br': 'Linguagem',
  },
  country: {
    'en-us': 'Country',
    'ru-ru': 'Страна',
    'es-es': 'País',
    'fr-fr': 'Pays',
    'uk-ua': 'Країна',
    'de-ch': 'Land',
    'pt-br': 'País',
  },
  viewRecord: {
    'en-us': 'View Record',
    'ru-ru': 'Просмотреть запись',
    'es-es': 'Ver registro',
    'fr-fr': "Afficher l'enregistrement",
    'uk-ua': 'Переглянути запис',
    'de-ch': 'Datensatz anzeigen',
    'pt-br': 'Ver registro',
  },
  nullInline: {
    'en-us': '(null)',
    'ru-ru': '(нулевой)',
    'es-es': '(nulo)',
    'fr-fr': '(nul)',
    'uk-ua': '(нуль)',
    'de-ch': '(null)',
    'pt-br': '(nulo)',
  },
  filePickerMessage: {
    comment: 'Generic. Could refer to any file',
    'en-us': 'Choose a file or drag it here',
    'ru-ru': 'Выберите файл или перетащите его сюда',
    'es-es': 'Elija un archivo o arrástrelo aquí',
    'fr-fr': 'Choisissez un fichier ou faites-le glisser ici',
    'uk-ua': 'Виберіть файл або перетягніть його сюди',
    'de-ch': 'Wählen eine Datei oder ziehen sie hierhin',
    'pt-br': 'Selecione um arquivo ou arraste-o aqui',
  },
  selectedFileName: {
    'en-us': 'Selected file',
    'ru-ru': 'Выбранный файл',
    'es-es': 'Fichero seleccionado',
    'fr-fr': 'Fichier sélectionné',
    'uk-ua': 'Вибраний файл',
    'de-ch': 'Gewählte Datei',
    'pt-br': 'Arquivo selecionado',
  },
  all: {
    'en-us': 'All',
    'ru-ru': 'Все',
    'es-es': 'Todo',
    'fr-fr': 'Tous',
    'uk-ua': 'всі',
    'de-ch': 'Alle',
    'pt-br': 'Todos',
  },
  unused: {
    'en-us': 'Unused',
    'ru-ru': 'Неиспользованный',
    'es-es': 'Sin usar',
    'fr-fr': 'Inutilisé',
    'uk-ua': 'Невикористаний',
    'de-ch': 'Unbenutzt',
    'pt-br': 'Não utilizado',
  },
  ordinal: {
    'en-us': 'Ordinal',
    'ru-ru': 'Порядковый',
    'es-es': 'Ordinal',
    'fr-fr': 'Ordinal',
    'uk-ua': 'Порядковий',
    'de-ch': 'Reihenfolge',
    'pt-br': 'Ordinal',
  },
  export: {
    'en-us': 'Export',
    'ru-ru': 'Экспорт',
    'es-es': 'Exportar',
    'fr-fr': 'Exporter',
    'uk-ua': 'Експорт',
    'de-ch': 'Export',
    'pt-br': 'Exportar',
  },
  import: {
    'en-us': 'Import',
    'ru-ru': 'Импорт',
    'es-es': 'Importar',
    'fr-fr': 'Importer',
    'uk-ua': 'Масове вирішення',
    'de-ch': 'Import',
    'pt-br': 'Importar',
  },
  dismiss: {
    'en-us': 'Dismiss',
    'ru-ru': 'Увольнять',
    'es-es': 'Descartar',
    'fr-fr': 'Rejeter',
    'uk-ua': 'Відхилити',
    'de-ch': 'Ablehnen',
    'pt-br': 'Liberar',
  },
  id: {
    'en-us': 'ID',
    'ru-ru': 'ИДЕНТИФИКАТОР',
    'es-es': 'ID',
    'fr-fr': 'IDENTIFIANT',
    'uk-ua': 'ID',
    'de-ch': 'ID',
    'pt-br': 'EU IA',
  },
  filter: {
    'en-us': 'Filter',
    'ru-ru': 'Фильтр',
    'es-es': 'Filtrar',
    'fr-fr': 'Filtre',
    'uk-ua': 'фільтр',
    'de-ch': 'Filter',
    'pt-br': 'Filtro',
  },
  results: {
    'en-us': 'Results',
    'ru-ru': 'Результаты',
    'es-es': 'Resultados',
    'fr-fr': 'Résultats',
    'uk-ua': 'Результати',
    'de-ch': 'Resultate',
    'pt-br': 'Resultados',
  },
  downloadErrorMessage: {
    'en-us': 'Download Error Message',
    'ru-ru': 'Сообщение об ошибке загрузки',
    'es-es': 'Mensaje de error de descarga',
    'fr-fr': "Message d'erreur de téléchargement",
    'uk-ua': 'Завантажити повідомлення про помилку',
    'de-ch': 'Fehlermeldung herunterladen',
    'pt-br': 'Mensagem de erro de download',
  },
  copied: {
    'en-us': 'Copied!',
    'ru-ru': 'Скопировано!',
    'es-es': '¡Copiado!',
    'fr-fr': 'Copié !',
    'uk-ua': 'Скопійовано!',
    'de-ch': 'Wurde kopiert!',
    'pt-br': 'Copiado!',
  },
  copyToClipboard: {
    'en-us': 'Copy to clipboard',
    'ru-ru': 'Копировать в буфер обмена',
    'es-es': 'Copiar al portapapeles',
    'fr-fr': 'Copier dans le presse-papiers',
    'uk-ua': 'Копіювати в буфер обміну',
    'de-ch': 'In Zwischenablage kopieren',
    'pt-br': 'Copiar para a área de transferência',
  },
  selected: {
    'en-us': 'Selected',
    'ru-ru': 'Выбранный',
    'es-es': 'Seleccionado',
    'fr-fr': 'Choisi',
    'uk-ua': 'Вибране',
    'de-ch': 'Ausgewählt',
    'pt-br': 'Selecionado',
  },
  expand: {
    'en-us': 'Expand',
    'ru-ru': 'Расширять',
    'es-es': 'Desplegar',
    'fr-fr': 'Développer',
    'uk-ua': 'Розгорнути',
    'de-ch': 'Aufklappen',
    'pt-br': 'Expandir',
  },
  expandAll: {
    'en-us': 'Expand All',
    'ru-ru': 'Развернуть все',
    'es-es': 'Desplegar todo',
    'fr-fr': 'Développer tout',
    'uk-ua': 'Розгорнути все',
    'de-ch': 'Alle aufklappen',
    'pt-br': 'Expandir tudo',
  },
  collapse: {
    'en-us': 'Collapse',
    'es-es': 'Contraer',
    'fr-fr': 'Effondrement',
    'ru-ru': 'Крах',
    'uk-ua': 'Згорнути',
    'de-ch': 'Zuklappen',
    'pt-br': 'Colapso',
  },
  collapseAll: {
    'en-us': 'Collapse All',
    'ru-ru': 'Свернуть все',
    'es-es': 'Contraer todo',
    'fr-fr': 'Tout réduire',
    'uk-ua': 'Закрити все',
    'de-ch': 'Alle zuklappen',
    'pt-br': 'Recolher tudo',
  },
  reset: {
    'en-us': 'Reset',
    'ru-ru': 'Перезагрузить',
    'es-es': 'Reiniciar',
    'fr-fr': 'Réinitialiser',
    'uk-ua': 'Скинути',
    'de-ch': 'Zurücksetzen',
    'pt-br': 'Reiniciar',
  },
  select: {
    'en-us': 'Select',
    'ru-ru': 'Выбирать',
    'es-es': 'Seleccionar',
    'fr-fr': 'Sélectionner',
    'uk-ua': 'Виберіть',
    'de-ch': 'Auswählen',
    'pt-br': 'Selecione',
  },
  none: {
    'en-us': 'None',
    'ru-ru': 'Никто',
    'es-es': 'Ninguno',
    'fr-fr': 'Aucun',
    'uk-ua': 'Жодного',
    'de-ch': 'Keine',
    'pt-br': 'Nenhum',
  },
  noneAvailable: {
    'en-us': 'None available',
    'ru-ru': 'Нет доступных',
    'es-es': 'Ninguno disponible',
    'fr-fr': 'Aucun disponible',
    'uk-ua': 'Немає доступних',
    'de-ch': 'Keine Verfügbar',
    'pt-br': 'Nenhum disponível',
  },
  countLine: {
    comment: 'Example usage: Record Sets (1,234)',
    'en-us': '{resource:string} ({count:number|formatted})',
    'ru-ru': '{resource:string} ({count:number|formatted})',
    'es-es': '{resource:string} ({count:number|formatted})',
    'fr-fr': '{resource:string} ({count:number|formatted})',
    'uk-ua': '{resource:string}({count:number|formatted})',
    'de-ch': '{resource:string} ({count:number|formatted})',
    'pt-br': '{resource:string} ({count:number|formatted})',
  },
  countLineOrMore: {
    comment: 'Example usage: Record Sets (1,234+)',
    'en-us': '{resource:string} ({count:number|formatted}+)',
    'de-ch': '{resource:string} ({count:number|formatted}+)',
    'es-es': '{resource:string} ({count:number|formatted}+)',
    'fr-fr': '{resource:string} ({count:number|formatted}+)',
    'pt-br': '{resource:string} ({count:number|formatted}+)',
    'ru-ru': '{resource:string} ({count:number|formatted}+)',
    'uk-ua': '{resource:string} ({count:number|formatted}+)',
  },
  jsxCountLine: {
    comment: 'Example usage: Record Sets (1,234)',
    'en-us': '{resource:string} <wrap>({count:number|formatted})</wrap>',
    'ru-ru': '{resource:string} <wrap>({count:number|formatted})</wrap>',
    'es-es': '{resource:string} <wrap>({count:number|formatted})</wrap>',
    'fr-fr': '{resource:string} <wrap>({count:number|formatted})</wrap>',
    'uk-ua': "{resource:string} <wrap>({count:number|formatted})</wrap>'",
    'de-ch': '{resource:string} <wrap>({count:number|formatted})</wrap>',
    'pt-br': '{resource:string} <wrap>({count:number|formatted})</wrap>',
  },
  colonHeader: {
    comment: `
      Example usage: "Choose collection:". Used only if there is nothing else on
      this line after the colon heading
    `,
    'en-us': '{header:string}:',
    'ru-ru': '{header:string}:',
    'es-es': '{header:string}:',
    'fr-fr': '{header:string} :',
    'uk-ua': "{header:string}':",
    'de-ch': '{header:string}:',
    'pt-br': '{header:string}:',
  },
  colonLine: {
    comment: `
      Example usage: "Created by: Full Name" OR "Record Set: Record Set Name"
    `,
    'en-us': '{label:string}: {value:string}',
    'ru-ru': '{label:string}: {value:string}',
    'es-es': '{label:string}: {value:string}',
    'fr-fr': '{label:string} : {value:string}',
    'uk-ua': "{label:string}: {value:string}'",
    'de-ch': '{label:string}: {value:string}',
    'pt-br': '{label:string}: {value:string}',
  },
  jsxColonLine: {
    comment: `
      Example usage: "Created by: Full Name" OR "Record Set: Record Set Name"
    `,
    'en-us': '{label:string}: <wrap />',
    'ru-ru': '{label:string}: <wrap />',
    'es-es': '{label:string}: <wrap />',
    'fr-fr': '{label:string} : <wrap />',
    'uk-ua': '{label:string}: <wrap />',
    'de-ch': '{label:string}: <wrap />',
    'pt-br': '{label:string}: <wrap />',
  },
  bulkSelect: {
    'en-us': 'Bulk Select',
    'es-es': 'Selección masiva',
    'de-ch': 'Mehrfachauswahl',
    'fr-fr': 'Sélection en masse',
    'ru-ru': 'Массовый выбор',
    'uk-ua': 'Масовий вибір',
    'pt-br': 'Seleção em massa',
  },
  bulkReturn: {
    'en-us': 'Bulk Return',
    'de-ch': 'Massenrückgabe',
    'es-es': 'Devolución masiva',
    'fr-fr': 'Retour en masse',
    'ru-ru': 'Массовый возврат',
    'uk-ua': 'Масове повернення',
    'pt-br': 'Devolução em massa',
  },
  bulkResolve: {
    'en-us': 'Bulk Resolve',
    'de-ch': 'Massenauflösung',
    'es-es': 'Resolución masiva',
    'fr-fr': 'Résolution en vrac',
    'ru-ru': 'Массовое решение',
    'uk-ua': 'Масове вирішення',
    'pt-br': 'Resolução em massa',
  },
  timeRemaining: {
    'en-us': 'Time remaining',
    'es-es': 'Tiempo restante',
    'fr-fr': 'Temps restant',
    'ru-ru': 'Оставшееся время',
    'uk-ua': 'Час, що залишився',
    'de-ch': 'Noch verbleibende Zeit',
    'pt-br': 'Tempo restante',
  },
  unlimited: {
    'en-us': 'Unlimited',
    'de-ch': 'Unbegrenzt',
    'es-es': 'Ilimitado',
    'fr-fr': 'Illimité',
    'ru-ru': 'Безлимитный',
    'uk-ua': 'Необмежений',
    'pt-br': 'Ilimitado',
  },
  change: {
    comment: 'Verb',
    'en-us': 'Change',
    'de-ch': 'Ändern',
    'es-es': 'Cambiar',
    'fr-fr': 'Changement',
    'ru-ru': 'Изменять',
    'uk-ua': 'Зміна',
    'pt-br': 'Mudar',
  },
  dontShowAgain: {
    'en-us': "Don't show this again",
    'es-es': 'No volver a mostrar esto',
    'fr-fr': 'Ne plus afficher ceci',
    'ru-ru': 'Больше не показывать',
    'uk-ua': 'Не показувати це знову',
    'de-ch': 'Zeig das nicht noch einmal',
    'pt-br': 'Não mostrar isso novamente',
  },
  multipleFilePickerMessage: {
    'en-us': 'Choose files or drag them here',
    'de-ch': 'Dateien auswählen oder hierher ziehen',
    'es-es': 'Seleccione los archivos o arrástrelos hasta aquí',
    'fr-fr': 'Choisissez des fichiers ou faites-les glisser ici',
    'ru-ru': 'Выберите файлы или перетащите их сюда',
    'uk-ua': 'Виберіть файли або перетягніть їх сюди',
    'pt-br': 'Selecione os arquivos ou arraste-os aqui',
  },
  zoom: {
    'en-us': 'Zoom In',
    'fr-fr': 'Zoomer',
    'de-ch': 'Vergrößern',
    'es-es': 'Acercar',
    'pt-br': 'Ampliar',
    'ru-ru': 'Увеличить масштаб',
    'uk-ua': 'Збільшити масштаб',
  },
  unzoom: {
    'en-us': 'Zoom Out',
    'fr-fr': 'Dézoomer',
    'de-ch': 'Herauszoomen',
    'es-es': 'Alejar',
    'pt-br': 'Diminuir o zoom',
    'ru-ru': 'Уменьшить масштаб',
    'uk-ua': 'Зменшити масштаб',
  },
} as const);
